<template lang="pug">
.container.col-centered
  .row
    h2.main_title
      | InstaViewer
      .pull-right
        button.btn.btn-primary(v-on:click="handleShowModal('upload')" v-if="user.role === 'admin'")
          span.glyphicon.glyphicon-plus
          span  New
        button.btn.btn-default(@click="showUpgradeGuide = true" style="margin-left: 8px;")
          span.glyphicon.glyphicon-book
          span  Upgrade Guide
    .col-md-12.function_bar(style="display:flex; justify-content: space-between; align-items: center;")
      .form-group
        label.control_label
          | Search:
        tooltip(effect="scale" placement="bottom" content="Search by version or release notes")
          input.form-control(v-model="temporarySearchQuery" @keydown.enter="applySearchQuery" placeholder="Search..." style="display: inline-block; width: auto; vertical-align: middle;")
      .form-group(v-if="user.role === 'admin' || isIntrising")
        label.control_label
          | Status:
        v-select(v-bind:value.sync='logFilter.status.value' v-bind:options='logFilter.status.opts')
    spinner(v-ref:spinner size="md" show="true" text="Loading...")
    div(v-if="firmwareLoaded")
      pagination(
        v-bind:sort-method.sync="sortMethod"
        v-bind:sort-method-opts="sortMethodOpts"
        v-bind:count-of-page.sync="countOfPage"
        v-bind:curr-page.sync="currPage"
        v-bind:count-of-pagination="countOfPagination"
        v-bind:curr-pagination-sec.sync='currPaginationSec'
        v-bind:target-ary.sync='searchFilteredTotalLog'
        v-bind:expand-all.sync='expandAll'
        v-bind:show-toggle-expansion-btn='true'
      )
      .col-md-12
        table.table.table-bordered.table-hover.log_table
          tr(v-for="($index, p) in searchFilteredTotalLog | limitBy countOfPage pageStart")
            td {{$index + 1 + pageStart}}
            td.single_log
              .media(style="overflow: visible;")
                .media-left
                  .media-object.device_icon(v-bind:class="p.category")
                    img(v-bind:src="getIconSrc(p.category)")
                .media-body(style="overflow: visible;")
                  .media-top
                    span.version
                      span(style="margin-right: 4px" v-html='highlightMatches(p.version, searchQuery)')
                      span.glyphicon.glyphicon-link(class="copy-icon" @click="copyToClipboard(p.version)" style="font-size: 14px;")
                    span.time
                      span.glyphicon.glyphicon-time
                      span(v-if="sortMethod.name !== 'updatedAt'") Released at {{ p.createdAt | fromNow }}
                      span(v-if="sortMethod.name === 'updatedAt'") Updated at {{ p.updatedAt | fromNow }}
                    span.model.type_tag.base_black.base_white_bg(v-if="p.isReadOnly && user.role === 'admin'") ReadOnly
                    .action_buttons.pull-right
                      .btn-group
                        button.btn.btn-sm.btn-default(@click="handleShowModal('update', p['.key'], $index)" v-if="user.role === 'admin'")
                          span.glyphicon.glyphicon-pencil
                        button.btn.btn-sm.btn-default(@click="handleShowDeleteConfirm(p['.key'], p.category)" v-if="user.role === 'admin'")
                          span.glyphicon.glyphicon-trash
                        a.btn.btn-sm.btn-default(v-if="p.status === 'release' || user.role === 'admin' || isIntrising" v-on:click='handleDownload(p.url, $event)' v-bind:disabled="p.url === ''")
                          span.glyphicon.glyphicon-cloud-download
                          span  Firmware
                        a.btn.btn-sm.btn-default(v-if="p.status === 'release' || user.role === 'admin'" v-on:click='handleDownload(p.testReportUrl, $event)' v-bind:disabled="p.testReportUrl === ''")
                          span.glyphicon.glyphicon-list-alt
                          span  Test Report
                  .media-middle
                    line-table(title='MD5' v-bind:content='p.md5' v-if='p.md5 != null && p.md5.length !== 0')
                    line-table(title='Model' v-bind:is-md="true" v-bind:content='p.modelTxt' v-if='p.modelTxt != null && p.modelTxt.length !== 0')
                    line-table(
                      title='Release Notes'
                      v-bind:is-md="true"
                      v-bind:default-collapse="!(searchQuery.trim() !== '' && p.releaseNote?.toLowerCase().includes(searchQuery.toLowerCase()))"
                      v-bind:content='highlightMatches(p.releaseNote, searchQuery, false)'
                      v-if='p.releaseNote && p.releaseNote.length !== 0'
                      v-bind:expand-all='expandAll'
                    )
                      span.time(slot="header-extra" v-if="p.releaseNoteUpdatedAt" style="margin-left: 8px;")
                        span.glyphicon.glyphicon-time
                        span(v-if="p.releaseNoteUpdatedBy") Updated by {{p.releaseNoteUpdatedBy}} {{p.releaseNoteUpdatedAt | fromNow}}
                        span(v-else) Updated {{p.releaseNoteUpdatedAt | fromNow}}
                    div(v-if='(user.role === "admin" || isIntrising) && p.hasInternalLog' @click="fetchInternalLog(p['.key'])")
                      line-table(
                        title='Internal Logs'
                        v-bind:is-md="true"
                        v-bind:default-collapse="true"
                        v-bind:content='internalLogs[p[".key"]] || ""'
                        v-bind:expand-all='expandAll'
                      )
            td.badge_group
              .customized__badge(v-bind:class="p.status")
                span {{p.status}}
      .col-md-12(v-if="searchFilteredTotalLog.length <= 0")
        h3.text-center.text-muted No Data
  modal(
    v-bind:title.sync='modalTitle'
    v-bind:ok-text.sync='okText'
    backdrop='false'
    v-bind:callback='modalCb'
    v-bind:show.sync='showModal')
    .modal-body.upload_modal(slot='modal-body')
      .col-md-12.clearfix.col-centered
        .form-group.col-md-12.clearfix(v-if='isUpdate')
          .col-md-3.form_label.clearfix
            label.control_label
              | Last update:
          .col-md-9.no_pad.clearfix
            input.form-control.input-sm(v-model='isUpdatedAt' readonly)
        .form-group.col-md-12.clearfix
          .col-md-3.form_label.clearfix
            label.control_label
              | Release Date:
          .col-md-9.no_pad.clearfix
            input.form-control.input-sm(v-model='isReleasedAt' readonly v-if="user.role !== 'admin'")
            datepicker(v-bind:value.sync="isReleasedAt" v-bind:format="'yyyy/M/dd'" placeholder="Default is current time." v-else)
        .form-group.col-md-12.clearfix
          .col-md-3.form_label.clearfix
            label.control_label
              | Category:
          .col-md-9.no_pad.clearfix
            v-select(v-bind:options='category' v-bind:value.sync='selectedCategory' v-bind:disabled="user.role !== 'admin'")
        .form-group.col-md-12.clearfix.version
          .col-md-3.form_label.clearfix
            label.control_label
              | Version:
          .col-md-9.no_pad.clearfix
            input.form-control.input-sm(v-model='version' v-bind:placeholder.sync='versionPlaceholder' v-bind:class="{'error': showInvalidMsg}" v-bind:readonly="user.role !== 'admin'")
          span.text-danger(v-if='showInvalidMsg')
            | Please follow the format of placeholder
        .form-group.col-md-12.clearfix
          .col-md-3.form_label.clearfix
            label.control_label
              | Firmware
              |
              span.glyphicon.glyphicon-cloud-download
              | :
          .col-md-9.no_pad.clearfix
            input.form-control.input-sm(v-model='url' placeholder='www.google.com' v-bind:readonly="user.role !== 'admin'")
        .form-group.col-md-12.clearfix
          .col-md-3.form_label.clearfix
            label.control_label
              | MD5 :
          .col-md-9.no_pad.clearfix
            input.form-control.input-sm(v-model='md5' placeholder='' v-bind:readonly="user.role !== 'admin'")
        .form-group.col-md-12.clearfix
          .col-md-3.form_label.clearfix
            label.control_label
              | Test Report:
          .col-md-9.no_pad.clearfix
            input.form-control.input-sm(v-model='testReportUrl' placeholder='www.google.com' v-bind:readonly="user.role !== 'admin'")
        .form-group.col-md-12.clearfix
          .col-md-3.form_label.clearfix
            label.control_label
              | Status:
          .col-md-9.no_pad.clearfix
            v-select(v-bind:options='status' v-bind:value.sync='selectedStatus' v-bind:disabled="user.role !== 'admin'")
        .form-group.col-md-12.clearfix.larger_form_group(v-if='isUpdate && modelTxt')
          .col-md-3.form_label.clearfix
            label.control_label
              | Model:
          .col-md-9.no_pad.clearfix
            textarea.form-control(v-model='modelTxt' placeholder='' v-bind:disabled="user.role !== 'admin'")
        .form-group.col-md-12.clearfix.larger_form_group
          .col-md-3.form_label.clearfix
            label.control_label
              | Release Notes:
          .col-md-9.no_pad.clearfix
            textarea.form-control(v-model='releaseNote' placeholder='' v-bind:disabled="user.role !== 'admin'")
        .form-group.col-md-12.clearfix.larger_form_group(v-if="user.role === 'admin' || isIntrising")
          .col-md-3.form_label.clearfix
            label.control_label
              | Internal Logs:
          .col-md-9.no_pad.clearfix
            textarea.form-control(v-model='internalLog' placeholder='' v-bind:disabled="user.role !== 'admin'")
        .form-group.col-md-12.clearfix.larger_form_group(v-if="user.role === 'admin'")
          .col-md-3.form_label.clearfix
            label.control_label(style="padding-top:4px;") Is Read Only:
          .col-md-9.no_pad.clearfix
            checkbox(:checked.sync="isReadOnlyStr" value="true")
  modal(title='Upgrade Guide' v-bind:show.sync='showUpgradeGuide' effect='fade' width='800px')
    .modal-body(slot='modal-body')
      p Firmware upgrade standard operating procedures (SOP) for InstaViewer.
      table.table.table-bordered(style='margin-bottom: 0; table-layout: fixed;')
        colgroup
          col(style='width: 160px;')
          col
          col(style='width: 200px;')
        thead
          tr
            th Platform
            th Title
            th Download
        tbody
          tr(v-if='upgradeGuideList.length === 0')
            td.text-center.text-muted(colspan='3') No upgrade guides available.
          tr(v-for='doc in upgradeGuideList')
            td.text-vcenter(style='white-space: normal; word-break: break-word;') {{guideProductList(doc).join(', ')}}
            td.text-vcenter(style='white-space: normal; word-break: break-word;') {{doc.title}}
            td.text-center
              button.btn.btn-sm.btn-default(@click='handleDownload(doc.url, $event)' v-bind:disabled='!doc.url')
                span.glyphicon.glyphicon-cloud-download
                span  Download
    .modal-footer(slot='modal-footer')
      button.btn.btn-default(@click='showUpgradeGuide = false') Close
  modal(
    title='Confirm'
    v-bind:show.sync='showDeleteConfirm')
    .modal-body(slot='modal-body')
      h4.text-center Are you sure to delete?
    .modal-footer(slot='modal-footer')
      button.btn.btn-default(@click='showDeleteConfirm = false')
        | No
      button.btn.btn-danger(@click='applyDelete')
        | Yes
  alert(v-bind:show.sync="showAlert" placement="top" duration="5000" type="danger" width="400px" dismissable)
    span(class="icon-info-circled alert-icon-float-left")
    h4 The following fields are required:
      ul
        li(v-if="!version") Version
        li(v-if="!url") Firmware
        li(v-if="!selectedStatus") Status
        li(v-if="!isReleasedAt") Release Date
        li(v-if="!md5") MD5
        li(v-if="md5 && md5.length !== 32") MD5 must be 32 characters
</template>
<script>
import moment from 'moment'
import { alert, datepicker, dropdown, modal, select, spinner, checkbox, tooltip } from 'vue-strap'
import pagination from '../common/Pagination.vue'
import lineTable from '../common/LinedTable.vue'
import { getDb, getFireBase, getIconSrc, filterOptions, naturalSorting, resolveDownloadUrl, getLabelFromCategory } from '../../index.js'
import permissionsMixin from '../../mixins/permissionsMixin.js'
import searchMixin from '../../mixins/searchMixin.js'
import _ from 'lodash'

const fb = getFireBase()
const VIEWER_CATEGORY = [{ label: 'InstaViewer', value: 'viewer' }]
const SWITCH_CUSTOM = filterOptions.custom

export default {
  mixins: [permissionsMixin, searchMixin],
  components: {
    alert,
    datepicker,
    dropdown,
    modal,
    pagination,
    'v-select': select,
    'line-table': lineTable,
    spinner,
    checkbox,
    tooltip
  },
  vuex: {
    getters: {
      user: state => state.user,
      firmwareList: state => state.firmwareList,
      firmwareLoaded: state => state.firmwareLoaded
    }
  },
  data () {
    return {
      mibEntries: [],
      countOfPage: 50,
      currPage: 1,
      countOfPagination: 5,
      currPaginationSec: 1,
      sortMethod: {
        name: 'createdAt',
        asc: false
      },
      sortMethodOpts: [
        {
          label: 'Sort by Release Date',
          value: 'createdAt'
        },
        {
          label: 'Sort by Update Time',
          value: 'updatedAt'
        },
        {
          label: 'Sort by Version',
          value: 'version'
        }
      ],
      category: [],
      selectedCategory: 'viewer',
      selectedCustom: 'intrising',
      selectedStatus: 'develop',
      version: '',
      customOpts: [],
      firmwareLayer: null,
      url: '',
      md5: '',
      testReportUrl: '',
      modelTxt: '',
      releaseNote: '',
      originalReleaseNote: '',
      internalLog: '',
      isReadOnlyStr: '',
      showModal: false,
      showAlert: false,
      modalTitle: '',
      okText: '',
      modalCb: function () {},
      editingKey: '',
      editingCategory: '',
      showDeleteConfirm: false,
      status: filterOptions.status.firmware,
      logFilter: {
        custom: {
          opts: [],
          value: 'any'
        },
        category: {
          opts: [],
          value: 'viewer'
        },
        status: {
          opts: [],
          value: 'any'
        }
      },
      isUpdate: false,
      isUpdatedAt: '',
      isReleasedAt: '',
      versionPlaceholder: 'V1.10.1',
      showInvalidMsg: false,
      firmware: {},
      internalLogs: {},
      temporarySearchQuery: '',
      searchQuery: '',
      expandAll: false,

      showUpgradeGuide: false,
      upgradeGuideList: []
    }
  },
  ready () {
    this.$refs.spinner.show()
    if (this.firmwareLoaded) {
      this.$nextTick(() => this.$refs.spinner.hide())
    }
    const optAny = { label: 'Any', value: 'any' }
    this.category = _.cloneDeep(VIEWER_CATEGORY)
    this.selectedCategory = 'viewer'
    this.logFilter.category.opts = _.cloneDeep(VIEWER_CATEGORY)
    this.logFilter.category.value = 'viewer'
    this.logFilter.custom.opts = _.cloneDeep(SWITCH_CUSTOM)
    this.logFilter.custom.opts.unshift(optAny)
    this.logFilter.status.opts = _.cloneDeep(filterOptions.status.firmware)
    this.logFilter.status.opts.unshift(optAny)
    this.customOpts = SWITCH_CUSTOM

    this.logFilter.status.value = this.$route.query.status || 'any'
    this.temporarySearchQuery = this.$route.query.search || ''
    this.searchQuery = this.$route.query.search || ''

    getDb().ref('documentation').orderByChild('type').equalTo('upgrade_guide').on('value', sn => {
      const viewerGuides = _.transform(sn.val(), (result, value, key) => {
        if (Object.values(value.products || {}).includes('viewer')) { result.push(value) }
      }, [])
      const latest = _.maxBy(viewerGuides, 'createdAt')
      this.upgradeGuideList = latest ? [latest] : []
    })

  },
  computed: {
    pageStart () {
      return (this.currPage - 1) * this.countOfPage
    },
    totalLog () {
      const { name, asc: isAsc } = this.sortMethod
      if (name === 'version') {
        return naturalSorting(_.filter(this.firmwareList, (x) => x.version), 'version', isAsc ? 'asc' : 'desc')
      } else {
        return _.orderBy(this.firmwareList, [name], [isAsc ? 'asc' : 'desc'])
      }
    },
    categoryFilteredTotalLog () {
      return this.totalLog.filter(p => p.category === 'viewer')
    },
    statusFilteredTotalLog () {
      const canSeeDevelop = this.user.role === 'admin' || this.isIntrising
      if (canSeeDevelop) {
        return this.categoryFilteredTotalLog.filter(p => {
          return this.logFilter.status.value !== 'any' ? p.status === this.logFilter.status.value : typeof (_.find(this.logFilter.status.opts, {value: p.status})) !== 'undefined'
        })
      } else {
        return this.categoryFilteredTotalLog.filter(p => p.status !== 'develop')
      }
    },
    customFilteredTotalLog () {
      return this.statusFilteredTotalLog
    },
    searchFilteredTotalLog () {
      if (this.searchQuery.trim() === '') { return this.customFilteredTotalLog }
      return this.customFilteredTotalLog.filter(p => {
        return p.version.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
               p.custom.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
               (p.releaseNote !== undefined && p.releaseNote.toLowerCase().includes(this.searchQuery.toLowerCase()))
      })
    }
  },
  methods: {
    alert (type, title, content) {
      this.$dispatch('alert', { type, title, content })
    },
    handleDownload (url, e) {
      if (!url) return
      window.open(resolveDownloadUrl(url))
    },
    getIconSrc,
    handleShowModal (which, key, index) {
      this.editingKey = key
      if (which === 'upload') {
        this.modalTitle = 'Add firmware'
        this.isUpdate = false
        this.okText = 'Add'
        this.internalLog = ''
        this.modelTxt = ''
        this.releaseNote = ''
        this.originalReleaseNote = ''
        this.version = ''
        this.url = ''
        this.md5 = ''
        this.testReportUrl = ''
        this.isReadOnlyStr = ''
        this.isReleasedAt = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
        this.modalCb = this.applyUpload
      } else if (which === 'update') {
        this.modalTitle = 'Edit firmware'
        this.isUpdate = true
        let { updatedAt = '', createdAt = '', modelTxt = '', releaseNote = '', version, url, md5 = '', testReportUrl = '', custom, category, status, isReadOnly = false } = this.searchFilteredTotalLog[index + this.pageStart]
        this.isUpdatedAt = moment(updatedAt).format('YYYY-MM-DD HH:mm:ss')
        this.isReleasedAt = moment(createdAt).format('YYYY-MM-DD HH:mm:ss')
        this.internalLog = ''
        if (this.user.role === 'admin') {
          getDb().ref('firmwareInternalLog').child('pt').child(key).once('value').then(sn => {
            this.internalLog = sn.val() || ''
          })
        }
        this.modelTxt = modelTxt
        this.releaseNote = releaseNote
        this.originalReleaseNote = releaseNote
        this.selectedCategory = category
        this.selectedCustom = custom
        this.selectedStatus = status
        this.url = url
        this.md5 = md5
        this.testReportUrl = testReportUrl
        this.okText = 'Update'
        this.modalCb = this.applyUpdate
        this.version = version
        this.isReadOnlyStr = isReadOnly ? 'true' : null
      }
      this.showModal = true
    },
    handleShowDeleteConfirm (key, category) {
      this.editingKey = key
      this.editingCategory = category
      this.showDeleteConfirm = true
    },
    applyUpload () {
      if (!this.version || !this.url || !this.selectedStatus || !this.isReleasedAt || !this.md5 || this.md5.length !== 32) {
        this.showAlert = true
        return
      }
      let toPush = {
        customCategoryVersion: `intrising_viewer_${this.version}`,
        category: 'viewer',
        createdAt: (new Date(this.isReleasedAt)).getTime(),
        custom: 'intrising',
        releaseNote: this.releaseNote,
        md5: this.md5,
        status: this.selectedStatus,
        testReportUrl: this.testReportUrl,
        updatedAt: fb.database.ServerValue.TIMESTAMP,
        url: this.url,
        version: this.version,
        isReadOnly: this.isReadOnlyStr === 'true'
      }
      if (this.releaseNote) {
        toPush.releaseNoteUpdatedAt = fb.database.ServerValue.TIMESTAMP
        toPush.releaseNoteUpdatedBy = this.user.email
      }
      if (this.user.role === 'admin' && this.internalLog) {
        toPush.hasInternalLog = true
      }
      const newRef = getDb().ref('firmware').push(toPush)
      if (this.user.role === 'admin' && this.internalLog) {
        getDb().ref('firmwareInternalLog').child('pt').child(newRef.key).set(this.internalLog)
      }
      this.showModal = false
    },
    async applyUpdate () {
      if (this.user.role !== 'admin') return
      if (!this.version || !this.url || !this.selectedStatus || !this.isReleasedAt || !this.md5 || this.md5.length !== 32) {
        this.showAlert = true
        return
      }
      const releaseNoteChanged = this.releaseNote !== this.originalReleaseNote
      const update = {
        customCategoryVersion: `intrising_viewer_${this.version}`,
        category: 'viewer',
        createdAt: (new Date(this.isReleasedAt)).getTime(),
        custom: 'intrising',
        releaseNote: this.releaseNote,
        md5: this.md5,
        modelTxt: this.modelTxt || null,
        status: this.selectedStatus,
        testReportUrl: this.testReportUrl,
        updatedAt: fb.database.ServerValue.TIMESTAMP,
        url: this.url,
        version: this.version,
        isReadOnly: this.isReadOnlyStr === 'true',
        hasInternalLog: this.internalLog ? true : null
      }
      if (releaseNoteChanged) {
        update.releaseNoteUpdatedAt = fb.database.ServerValue.TIMESTAMP
        update.releaseNoteUpdatedBy = this.user.email
      }
      getDb().ref('firmware').child(this.editingKey).update(update)
      getDb().ref('firmwareInternalLog').child('pt').child(this.editingKey).set(this.internalLog || null)
      this.$set('internalLogs["' + this.editingKey + '"]', this.internalLog || '')
      this.showModal = false
    },
    applyDelete () {
      getDb().ref('firmware').child(this.editingKey).remove()
      if (this.user.role === 'admin') {
        getDb().ref('firmwareInternalLog').child('pt').child(this.editingKey).remove()
      }
      this.showDeleteConfirm = false
    },
    fetchInternalLog (fid) {
      if (this.user.role !== 'admin' && !this.isIntrising) return
      if (this.internalLogs[fid] !== undefined) return
      this.$set('internalLogs["' + fid + '"]', '')
      getDb().ref('firmwareInternalLog').child('pt').child(fid).once('value').then(sn => {
        this.$set('internalLogs["' + fid + '"]', sn.val() || '')
      })
    },
    prefetchVisibleInternalLogs () {
      if (this.user.role !== 'admin' && !this.isIntrising) return
      const visible = this.searchFilteredTotalLog.slice(this.pageStart, this.pageStart + this.countOfPage)
      for (const p of visible) {
        this.fetchInternalLog(p['.key'])
      }
    },
    guideProductList (doc) {
      const products = Object.values(doc.products || {})
      return products.map(v => getLabelFromCategory(v))
    },
    copyToClipboard (version) {
      const url = `${window.location.origin}/instaviewer?search=${version}`
      navigator.clipboard.writeText(url).then(() => {
        console.log('URL Copied to clipboard.')
      }).catch(err => {
        console.error('Copy Failed', err)
      })
    }
  },
  watch: {
    logFilter: {
      deep: true,
      handler: function (nv) {
        this.currPage = 1
        this.currPaginationSec = 1
      }
    },
    searchQuery: function (newQuery) {
      this.currPage = 1
      this.currPaginationSec = 1
    },
    expandAll (newVal) {
      if (newVal) this.prefetchVisibleInternalLogs()
    },
    firmwareLoaded (val) {
      if (val) this.$refs.spinner.hide()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../scss/_varaibles.scss';
@import '../../scss/_mixin.scss';
.upload_modal .form_label, .total, .function_bar .upload{
  text-align: right;
}
.function_bar {
  .upload{
    font-size: 20px;
  }
}
.form_label{
  padding: 5px 15px;
  white-space: nowrap;
}
.control_label{
  padding-right: 5px;
}
.text-vcenter {
  vertical-align: middle;
}
.upload_modal{
  .download{
    margin-left: -9px;
    margin-right: 9px;
  }
  .form-group{
    margin-bottom: 3px;
  }
  .form-group.larger_form_group{
    margin-bottom: 7px;
  }
}
.log_table{
  td {
    padding: 15px;
  }
  .version{
    display: inline-block;
    padding: 3px 7px 3px 0px;
    font-size: 20px;
  }
  .time{
    color: #d7d7d7;
    padding-right: 5px;
    .glyphicon{
      font-size: 10px;
      cursor: default;
      padding-right: 5px;
    }
    span{
      font-size: 12px;
    }
  }
}
textarea{
  min-height: 200px;
  resize: vertical;
}
.single_log{
  position: relative;
  padding-right: 0px !important;
  border-right: none;
}
.badge_group{
  position: relative;
  min-width: 65px;
  overflow: hidden;
  border-left: none;
}
.customized__badge{
  &.develop{
    @include genRightCornerBadge(50px, 18px, 14px, $warning, #000);
    right:-52px;
  }
  &.release{
    @include genRightCornerBadge(50px, 18px, 14px, $success, #fff);
    right:-48px;
  }
}
.error{
  border: 2px solid #e33;
}
.copy-icon {
  cursor: pointer;
  &:hover {
    color: #007bff;
  }
}
</style>



// WEBPACK FOOTER //
// Viewer.vue?a934794a